/**
 * Single source of truth for pricing-related data.
 * Used by Pricing.vue and SubscriptionPricingModal.vue
 */

export const creditCosts = {
    equipment: 5,
    creature: 10,
    character: 30,
    npc: 10,
    illustration_regen: 5,
    inpainting: 5,
    etch_populate: 15,
};

export const creditCostsDisplay = [
    { label: 'Equipment', cost: creditCosts.equipment },
    { label: 'Creatures', cost: creditCosts.creature },
    { label: 'Merchants', cost: creditCosts.npc },
    { label: 'Characters', cost: creditCosts.character },
    { label: 'Illustration Regen', cost: creditCosts.illustration_regen },
    { label: 'Inpainting', cost: creditCosts.inpainting },
];

export const freePlan = {
    id: 'free-plan',
    product_id: 'free',
    price_id_monthly: null,
    price_id_yearly: null,
    name: 'Free',
    description: 'Get started with your tabletop adventures - just create an account.',
    icon: 'fa-solid fa-hat-wizard',
    icon_color: '#74C0FC',
    price: {
        monthly: '0',
        yearly: '0',
        monthly_billed_yearly: '0'
    },
    currency: 'USD',
    features: [
        '<b class="text-blue-500">Workshop</b>',
        '<b data-highlight="credits"><span class="font-black text-green-500">50</span> Credits Monthly</b>',
        '<b class="text-gray-400">Equipment @ 5 credits</b>',
        '<b class="text-gray-400">Creatures @ 10 credits</b>',
        '<b class="text-gray-400">Characters @ 30 credits</b>',
        '<b data-highlight="simultaneous-generations" class="text-gray-400">1 Simultaneous Generation<sup>1</sup></b>',
        '<br>',
        '<b data-highlight="collections" class="text-indigo-500">Collections</b>',
        '<b data-highlight="collections" class="text-gray-400">2 Collections</b>',
        '<b data-highlight="collections" class="text-gray-400">25 items per collection</b>',
        '<br>',
        '<b data-highlight="etch" class="text-amber-500">Etch Map Editor</b>',
        '<b data-highlight="etch" class="text-gray-400">1 Project</b>',
        '<b data-highlight="etch" class="text-gray-400">5 Maps</b>',
        '<br>',
        '<b data-highlight="ai-assistants" class="text-cyan-400">AI Assistants (MCP)</b>',
        '<b data-highlight="ai-assistants" class="text-gray-400">Claude &amp; ChatGPT<sup>5</sup></b>',
    ],
    // Legacy format for backwards compatibility
    get featuresString() {
        return this.features.join('\n');
    },
    energy_max: 50,
    energy_replenish_amount: 50,
    energy_replenish_interval: 0,
    energy_unlimited: 0
};

export const pricingFootnotes = [
    { id: 1, text: 'Creatures, Merchants, Characters, Illustrations, and Equipment generations count towards this limit.' },
    { id: 2, text: 'Use your private content commercially without attribution, provided you hold the necessary intellectual property rights to your generated content.' },
    { id: 3, text: 'Toggle private mode in your account settings. Public content is released into the public domain (CC0). Private content retains commercial usage rights.' },
    { id: 4, text: 'Adaptive Audio uses your microphone to listen for narration and automatically adjusts the ambient music and lighting to match your campaign\'s mood and setting.' },
    { id: 5, text: 'Connect Tavern of Azoth to Claude or ChatGPT with our MCP server and create D&D 5e and Pathfinder 2 creatures, with art and printable sheets, right from the chat. Uses the same credits as the website.', link: { to: '/ai-assistants', text: 'How to connect' } },
];

export const pricingSupportNote = 'Tavern of Azoth is a <span class="font-semibold text-white">solo development project</span>. Subscriptions cover hosting and third-party generation costs &mdash; your support is what keeps the service online and improving.';

export const pricingCancellationNote = 'Once subscribed, you can manage your subscription or cancel at any time through the payment confirmation emails you receive.';

export const pricingDisclaimer = 'Credits reset at the beginning of each billing cycle and unused credits do not carry over.';

export const usageLimitsNote = 'Usage limits apply to ensure fair access for all users. Premium tiers have higher limits and priority access.';

export default {
    creditCosts,
    creditCostsDisplay,
    freePlan,
    pricingFootnotes,
    pricingSupportNote,
    pricingCancellationNote,
    pricingDisclaimer,
    usageLimitsNote,
};
